const filters = {
  namespaced: true,
  state: {
    missions: {},
    missions_default: {}, // unknown/useless until set externally
    missionsAssessmentPeriod: {},
  },
  mutations: {
    RESET_MISSIONS_FILTERS(state) {
      state.missions = Object.assign({}, state.missions_default);
    },
    SET_DEFAULT_MISSIONS_FILTERS(state, filters) {
      state.missions_default = filters;
    },
    // This method restores defaults plus provided filters
    SET_MISSIONS_FILTERS(state, filters) {
      const nextFilters = Object.assign({}, state.missions_defaults, filters);
      state.missions = nextFilters;
    },
    // This method replaces only the provided filter keys
    // (any other properites keep their current value).
    MERGE_MISSIONS_FILTERS(state, filters) {
      const nextFilters = Object.assign({}, state.missions, filters);
      state.missions = nextFilters;
    },
    SET_MISSIONS_ASSESSMENT_PERIOD(state, assessmentPeriod) {
      state.missionsAssessmentPeriod = assessmentPeriod;
    },
  },
  actions: {
    resetMissionsFilters({ commit }) {
      commit('RESET_MISSIONS_FILTERS');
    },
    setDefaultMissionsFilters({ commit }, filters) {
      commit('SET_DEFAULT_MISSIONS_FILTERS', filters);
    },
    setMissionsFilters({ commit }, filters) {
      commit('SET_MISSIONS_FILTERS', filters);
    },
    mergeMissionsFilters({ commit }, filters) {
      commit('MERGE_MISSIONS_FILTERS', filters);
    },
    setMissionsAssessmentPeriod({ commit }, assessmentPeriod) {
      commit('SET_MISSIONS_ASSESSMENT_PERIOD', assessmentPeriod);
    },
  },
  getters: {
    //
  },
};

export default filters;
